export const AUTH_REDIRECT_EVENT = 'fasttime:auth-redirect';

const DEFAULT_AUTH_DESTINATION = '/dashboard';
const LOGIN_PATH = '/login';

export const clearStoredAuth = () => {
  if (typeof window === 'undefined') return;

  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('user');
};

export const sanitizeReturnTo = (returnTo) => {
  if (typeof returnTo !== 'string') return '';
  if (!returnTo.startsWith('/') || returnTo.startsWith('//')) return '';
  if (returnTo.startsWith(`${LOGIN_PATH}?`) || returnTo === LOGIN_PATH) return '';
  return returnTo;
};

export const getLocationReturnTo = (location) => {
  if (!location) return DEFAULT_AUTH_DESTINATION;

  const returnTo = `${location.pathname || ''}${location.search || ''}${location.hash || ''}`;
  return sanitizeReturnTo(returnTo) || DEFAULT_AUTH_DESTINATION;
};

export const getCurrentReturnTo = () => {
  if (typeof window === 'undefined') return DEFAULT_AUTH_DESTINATION;

  return getLocationReturnTo(window.location);
};

export const buildLoginUrl = ({ returnTo, reason } = {}) => {
  const params = new URLSearchParams();
  const safeReturnTo = sanitizeReturnTo(returnTo);

  if (safeReturnTo) {
    params.set('returnTo', safeReturnTo);
  }

  if (reason) {
    params.set('reason', reason);
  }

  const query = params.toString();
  return query ? `${LOGIN_PATH}?${query}` : LOGIN_PATH;
};

export const getPostAuthDestination = (user, returnTo) => {
  const safeReturnTo = sanitizeReturnTo(returnTo);
  if (safeReturnTo) return safeReturnTo;
  return user?.isAdmin ? '/admin/overview' : DEFAULT_AUTH_DESTINATION;
};

export const emitAuthRedirect = ({ reason = 'session-expired', returnTo } = {}) => {
  if (typeof window === 'undefined') return;

  window.dispatchEvent(
    new CustomEvent(AUTH_REDIRECT_EVENT, {
      detail: {
        reason,
        returnTo: sanitizeReturnTo(returnTo) || getCurrentReturnTo(),
      },
    })
  );
};
